<template>
    <div class="page-content">
        <b-row>
            <b-col md="10">
                <page-breadcrumb title="Early Claim" class="mb-3" />
            </b-col>
        </b-row>
         <b-media>
            <section class="py-1">
                <h2 class="mb-2">Early Claim Report</h2>
                <!-- <div class="mb-2 d-flex justify-content-end">
                    <b-button @click="exportData" class="mt-0 mt-md-2 mr-1" variant="success">
                        Export
                    </b-button>
                </div> -->
                <early-claim-search-form @getList="getList" @exportData="exportData" />
                <b-card>
                <early-claim-table
                    @getList="getList"
                    :items="earlyClaim"
                    :is-loading="isLoading"
                    :query="query"
                    ref="earlyClaimTable"
                />
                </b-card>
            </section>
        </b-media>
        <b-pagination
            class="mt-auto"
            pills
            size="lg"
            align="center"
            v-model="current_page"
            :total-rows="total_items"
            :per-page="items_perpage"
        />
        
    </div>
</template>
<script>
import EarlyClaimSearchForm from './_components/EarlyClaimSearchForm.vue'
import EarlyClaimTable from './_components/EarlyClaimTable.vue'
import service from "../service"
export default {
    components:{
        EarlyClaimSearchForm,
        EarlyClaimTable
    },
    data(){
        return {
            earlyClaim: [],
            total_items: 0,
            current_page: 1,
            items_perpage: 50,
            isLoading: true,
            export_data: [],
            query: {
                time_range: {
                start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            }}
        }
    },
    watch: {
        current_page() {
            this.getList();
        },
    },
    created(){
        this.getList();
    },
    methods: {
        async getList(query = null) {
            let user = null
            if(query){
                this.query = query;
            }
            if (this.query.email){
                let response = await service.getUserProfile({emails: this.query.email});
                user = response.data.data[0];
                delete query.email;
                this.query.user_id = user._id;
            }
            else {
                delete this.query.user_id;
                delete this.query.email;
            }
            let response = await service.getList({
                page: this.current_page,
                limit: this.items_perpage,
                query: JSON.stringify(this.query)
            });
            if (response.data.type === "DATA") {
                this.earlyClaim = response.data.data.list;
                this.total_items = response.data.data.total;
            }
            this.isLoading = false
        },
        exportData(){
            this.$refs.earlyClaimTable.exportData();
        }
    }

}
</script>